document.addEventListener('DOMContentLoaded', function () {

  // ブログ記事ページ以外では何もしない
  if (!document.body.classList.contains('template--article')) return;

  // 記事トップ画像の image--root を取得
  const imageRoots = document.querySelectorAll(
    '.article--image .image--root'
  );

  imageRoots.forEach(function (root) {

    // 比率BOX（padding-top）を完全に無効化
    root.style.setProperty('padding-top', '0', 'important');
    root.style.setProperty('height', 'auto', 'important');

    const img = root.querySelector('img');
    if (!img) return;

    // img の absolute / cover を解除
    img.style.setProperty('position', 'static', 'important');
    img.style.setProperty('height', 'auto', 'important');
    img.style.setProperty('width', '100%', 'important');
    img.style.setProperty('object-fit', 'contain', 'important');
  });

});
